<template>
  <div class="wrap" v-if="!loading">
    <img class="icon" :src="icon" />
    <div class="pay-state">{{ status }}</div>
    <div class="btn" @click="handleComplete">完成</div>
  </div>
</template>

<script>
import Vue from "vue";
import { defineComponent, onMounted, ref } from "@vue/composition-api";

import { useRoute, useRouter } from "@/components/use/base";
import { jiayinPaymentResult } from "@/apis/jiayin";
import fail from "@/assets/images/jiaying-fail.png";
import success from "@/assets/images/jiaying-success.png";
import padding from "@/assets/images/jiaying-padding.png";

export default defineComponent({
  setup() {
    const icon = ref(success);
    const status = ref("");
    const count = ref(0);
    const router = useRouter();
    const statusEnum = {
      SUCCESS: "支付成功",
      FAIL: "支付失败",
      PENDING: "支付中",
      CANCEL: "取消支付",
    };
    const statusIcon = {
      SUCCESS: success,
      FAIL: fail,
      PENDING: padding,
      CANCEL: fail,
    };
    const route = useRoute();
    const vm = Vue.prototype;
    const loading = ref(true);
    const queryStatus = async () => {
      const res = await jiayinPaymentResult({
        payOrderNumber: route.query.payOrderNumber,
      });
      status.value = statusEnum[res.data.payStatus];
      icon.value = statusIcon[res.data.payStatus];
      // 轮询支付中的状态
      if (res.data.payStatus === "PENDING") {
        count.value++;
        if (count.value < 15) {
          setTimeout(queryStatus, 2000);
        }
      }
    };

    onMounted(async () => {
      const fetching = vm.$loading();
      try {
        await queryStatus();
      } finally {
        loading.value = false;
        fetching.clear();
      }
    });

    const handleComplete = () => {
      const pageUrl = route.query.pageUrl;
      if (pageUrl) {
        location.replace(decodeURIComponent(pageUrl));
      } else {
        router.replace({
          path: "/index",
          query: {
            channelSource: route.query.channelSource,
            orderId: route.query.orderId,
            info: route.query.info,
          },
        });
      }
    };

    return {
      icon,
      loading,
      status,
      handleComplete,
    };
  },
});
</script>

<style lang="less" scoped>
.wrap {
  min-height: 100vh;
  position: relative;
  overflow: hidden;

  .icon {
    height: 64px;
    width: 64px;
    display: block;
    margin: 0 auto;
    margin-top: 109px;
  }

  .pay-state {
    margin-top: 20px;
    font-weight: 500;
    font-size: 16px;
    color: #333333;
    line-height: 22px;
    text-align: center;
    margin-top: 20px;
  }

  .btn {
    position: fixed;
    left: 12px;
    right: 12px;
    bottom: 32px;
    font-weight: 500;
    font-size: 17px;
    color: #ffffff;
    line-height: 44px;
    text-align: center;
    background: linear-gradient(115deg, #4082e7 0%, #3254f2 100%);
    border-radius: 22px;
  }
}
</style>
